var installedModules = {};
var moduleToHandlerMapping = {
	3858: {
		getter: () => (__webpack_require__.e(810).then(() => (() => (__webpack_require__(7810))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	3888: {
		getter: () => (__webpack_require__.e(483).then(() => (() => (__webpack_require__(2483))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^18.2.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	656: {
		getter: () => (__webpack_require__.e(762).then(() => (() => (__webpack_require__(2762))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.11.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@emotion/react",
	},
	4339: {
		getter: () => (__webpack_require__.e(526).then(() => (() => (__webpack_require__(7145))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.3.8",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "zustand",
	},
	2879: {
		getter: () => (__webpack_require__.e(578).then(() => (() => (__webpack_require__(4578))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "11.11.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@emotion/styled",
	},
	8336: {
		getter: () => (__webpack_require__.e(5).then(() => (() => (__webpack_require__(6005))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.0.5",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cx/login",
	},
	6008: {
		getter: () => (Promise.all([__webpack_require__.e(677), __webpack_require__.e(12)]).then(() => (() => (__webpack_require__(8677))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.0.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cx/ui",
	},
	7766: {
		getter: () => (__webpack_require__.e(808).then(() => (() => (__webpack_require__(6808))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.0.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cx/zustand-saga",
	},
	4570: {
		getter: () => (__webpack_require__.e(919).then(() => (() => (__webpack_require__(6919))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^1.0.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "redux-saga-combine-watchers",
	},
	9355: {
		getter: () => (__webpack_require__.e(341).then(() => (() => (__webpack_require__(8341))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.4.4",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cx/ui-components",
	},
	8881: {
		getter: () => (__webpack_require__.e(908).then(() => (() => (__webpack_require__(2908))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.1.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@cx/analytics",
	},
	2012: {
		getter: () => (__webpack_require__.e(194).then(() => (() => (__webpack_require__(4194))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.13.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"12": [
		2012
	],
	"339": [
		4339
	],
	"573": [
		8881,
		2012
	],
	"629": [
		8336,
		6008,
		7766,
		4570
	],
	"656": [
		656
	],
	"842": [
		9355
	],
	"858": [
		3858
	],
	"879": [
		2879
	],
	"888": [
		3888
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}